import { IconDefinition } from "./types";

const refreshArrow: IconDefinition = {
  iconName: "refresh-arrow",
  width: 16,
  height: 16,
  svgPathData:
    "M1.825 10.75a6.78 6.78 0 006.195 4.038 6.768 6.768 0 10-6.155-9.587M1.381 1.381v4.113h4.113",
  iconType: "stroke",
};

export { refreshArrow };
